AgrimarketControllers.controller('userContractsV2TargetPriceController', ['$scope', '$rootScope', 'contractsService', 'cropsService', '$sce', 'columns', 'contractBaseService', 'enumFactory', '$location',
    function ($scope, $rootScope, contractsService, cropsService, $sce, columns, contractBaseService, enumFactory, $location) {

        var Init = function () {
            // Contrats objectifs
            $scope.tableDataVisible = columns.data.DataVisible.split(',');
            $scope.tableLibelle = columns.data.ColumnName.split(',');

            // Gestion du trie
            $scope.reverse = true;
            $scope.sortKey = "IdContractCommitment";
            $scope.pageNo = 1;
            $scope.max = 10;

            $scope.currentView = "TargetPrice";
            $scope.idProductSelected = "";
            $scope.idCropSelected = $rootScope.crop.IdCrop;
            $scope.idContractStateSelected = "";
            $scope.dateSelected = "";
            $scope.dateEndTargetPriceSelected = "";
            $scope.idTypeFixationSelected = "";
            $scope.titleTargetPricePopUp = $rootScope.editableObjectsFactory.EditableObjects.User_ContractFirmMonitoring_PopupChangeTargetPrice_Title.Content;
            GetContracts();
        };

        $scope.$watch("selectedIdContract", function (newValue, oldValue) {
            if ((newValue && oldValue !== newValue) || (!newValue && oldValue))
                $scope.GetContractsWithFilter();
        });

        $scope.$watch("dateFilter", function (newValue, oldValue) {
            if ((newValue && oldValue !== newValue) || (!newValue && oldValue))
                $scope.GetContractsWithFilter();
        });

        $scope.$watch("dateSelected", function (newValue) {
            if (newValue === "")
                $scope.dateFilter = "";
            else if (newValue) {
                //permet de gérer l'internalisation de tout les formats des dates possibles.
                //Au final nous faisons en sorte de la retrouvé au format dd/mm/yyyy.
                var pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
                var dt = new Date(newValue.replace(pattern, '$3-$2-$1'));
                var currentDate = new Date(dt.toString());
                var converDate = moment(currentDate);
                $scope.dateFilter = converDate.format('YYYY/MM/DD');
            }
        });


        $scope.$watch("dateEndTargetPriceFilter", function (newValue, oldValue) {
            if ((newValue && oldValue !== newValue) || (!newValue && oldValue))
                $scope.GetContractsWithFilter();
        });

        $scope.$watch("dateEndTargetPriceSelected", function (newValue) {
            if (newValue === "")
                $scope.dateEndTargetPriceFilter = "";
            else if (newValue) {
                //permet de gérer l'internalisation de tout les formats des dates possibles.
                //Au final nous faisons en sorte de la retrouvé au format dd/mm/yyyy.
                var pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
                var dt = new Date(newValue.replace(pattern, '$3-$2-$1'));
                var currentDate = new Date(dt.toString());
                var converDate = moment(currentDate);
                $scope.dateEndTargetPriceFilter = converDate.format('YYYY/MM/DD');
            }
        });

        var GetFiltersWithContracts = function () {
            $scope.loading = true;
            $scope.idProductSelected = "";
            $scope.selectedIdContract = "";
            $scope.dateSelected = "";
            $scope.dateEndTargetPriceSelected = "";
            $scope.idTypeFixationSelected = "";
            $scope.All = $rootScope.editableObjectsFactory.EditableObjects.All.Content;
            contractsService.GetFiltersForUserContractsTargetPriceByCrop($scope.idCropSelected, function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.errorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                } else {
                    if (data) {

                        $scope.lstProducts = data.LstProductVm;

                        if ($scope.lstProducts.length === 1)
                            $scope.idProductSelected = $scope.lstProducts[0].Id;
                        else if ($scope.lstProducts.length > 1)
                            $scope.lstProducts.unshift({ Id: "", Label: $scope.All });

                        $scope.lstTypeFixations = data.LstTypeFixationVm;

                        if ($scope.lstTypeFixations.length === 1)
                            $scope.idTypeFixationSelected = $scope.lstTypeFixations[0].Id;
                        else if ($scope.lstTypeFixations.length > 1)
                            $scope.lstTypeFixations.unshift({ Id: "", Label: $scope.All });


                        $scope.GetContractsWithFilter();
                    }
                }
            });
        };

        var GetDefaultCrop = function (callback) {
            cropsService.GetDefaultCrop(function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.errorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                } else {
                    if (data !== null) {
                        $scope.idCropSelected = data.IdCrop;
                        callback();
                    }
                }
            });
        };

        var GetContracts = function () {
            if (!$scope.idCropSelected) //Si on a pas de récolte de sélectionnée on prend celle par défaut
                GetDefaultCrop(GetContracts());
            else
                GetFiltersWithContracts();
        };

        $scope.GetContractsWithFilter = function () {
            if (!$scope.selectedIdContract) $scope.selectedIdContract = "";
            $scope.loading = true;
            contractsService.GetUserContractsTargetPricePaginate($scope.idCropSelected, $scope.idProductSelected, $scope.selectedIdContract, $scope.idContractStateSelected, $scope.dateFilter, $scope.dateEndTargetPriceFilter, $scope.idTypeFixationSelected, $scope.max, $scope.pageNo, $scope.sortKey, $scope.reverse, function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.errorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                } else {
                    $scope.total = data.Total;
                    $scope.contractCommitments = data.ListVm;
                    $scope.contractCommitments.forEach(function (item) {
                        item.showDetail = true;
                    });
                    $scope.loading = false;
                }
            });
        };

        $scope.Sort = function (sortKey, reverse) {
            $scope.sortKey = sortKey;
            $scope.reverse = reverse;
            $scope.GetContractsWithFilter();
        };

        $scope.GetData = function (pageNo) {
            $scope.pageNo = pageNo;
            $scope.GetContractsWithFilter();
        };

        $rootScope.onRefresh = function () {
            Init();
        };

        $scope.AsChangedCrop = function () {
            Init();
        };

        $scope.ChangeTargetPricePopUp = function (currentContract, openPopUp) {
            if (currentContract.IdTypeFixation == enumFactory.TypeFixations.Base.IdTypeFixation) { // Si contrat de base
                $scope.selectedContract = currentContract;
                $scope.selectedContract.NewQuantity = currentContract.Quantity;
                $scope.errorMessage = "";
                $scope.successMessage = "";
                $scope.titleTargetPricePopUp = $rootScope.editableObjectsFactory.EditableObjects.User_ContractFirmMonitoring_PopupChangeTargetPrice_Title.Content;
                $scope.ActionType = "edit";
                openPopUp();
            }
            else { // Si contrat ferme
                contractsService.GetContractTargetPrice(currentContract.IdContractOrContractBase, function (data, status) {
                    if (status !== null) {
                        if (status === 400)
                            $scope.errorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                    } else
                        $scope.selectedContract = data;
                    $scope.selectedContract.NewQuantity = currentContract.Quantity;
                    $scope.selectedContract.IdContractOrContractBase = $scope.selectedContract.IdContract;
                    $scope.selectedContract.OfferPriceCurrencyUnit = $scope.selectedContract.OfferPriceUpdatedWithCoeffCurrencyUnit;
                    $scope.selectedContract.TargetPriceCurrencyUnit = $scope.selectedContract.TargetPriceWithCoeffCurrencyUnit;

                    $scope.errorMessage = "";
                    $scope.successMessage = "";
                    $scope.titleTargetPricePopUp = $rootScope.editableObjectsFactory.EditableObjects.User_ContractFirmMonitoring_PopupChangeTargetPrice_Title.Content;
                    $scope.ActionType = "edit";
                    openPopUp();
                });
            }
        };

        $scope.ChkTargetPriceIsValid = function () {
            $scope.errorMessage = "";
            $scope.successMessage = "";
            $scope.errorMessage = contractsService.ChkTargetPriceIsValid($scope.selectedContract, $scope.selectedContract.OfferPriceUpdated);

            if ($scope.errorMessage !== null)
                return false;

            $scope.selectedContract.NewTargetPrice = Number($scope.selectedContract.NewTargetPrice);
            return true;
        };

        $scope.ChangeTargetPrice = function () {
            $scope.UpdateSuccessMessage = $rootScope.editableObjectsFactory.EditableObjects.Success_UserContractsFirmMonitoring_ChangeTargetPriceMessage.Content;

            if ($scope.selectedContract.IdTypeFixation == enumFactory.TypeFixations.Base.IdTypeFixation) { // Si contrat de base
                UpdateContractBase($scope.selectedContract, false);
            }
            else { // Si contrat ferme
                UpdateContract($scope.selectedContract, false);
            }
        };

        $scope.CancelContractPopUp = function (contractSelected, showPopUpContract) {
            $scope.PopUpMessageDeleteContract = "";
            $scope.errorMessage = "";
            $scope.successMessage = "";
            $scope.MessageDeleteContractFirmTargetPrice = $rootScope.editableObjectsFactory.EditableObjects.MessageDeleteContractFirmTargetPrice.Content;
            $scope.CanceledContract = $rootScope.editableObjectsFactory.EditableObjects.CanceledContract.Content;
            $scope.PopupCanceledContractsSelectedTitle = $scope.CanceledContract + " " + contractSelected.IdContractOrContractBase;

            if (contractSelected)
                $scope.PopUpMessageDeleteContract = $scope.MessageDeleteContractFirmTargetPrice;

            showPopUpContract(contractSelected);
        };

        $scope.CancelContract = function (contractSelected) {
            $scope.errorMessage = "";
            $scope.successMessage = "";
            $scope.UpdateSuccessMessage = $rootScope.editableObjectsFactory.EditableObjects.Success_UserContractsFirmMonitoring_CancelContractMessage.Content;

            if (contractSelected.IdTypeFixation == enumFactory.TypeFixations.Base.IdTypeFixation) { // Si contrat de base
                UpdateContractBase(contractSelected, true);
            }
            else { // Si contrat Ferme
                UpdateContract(contractSelected, true);
            }
        };

        var UpdateContract = function (contract, isCancel) {
            // Création de la vm utilisée pour la modification ou l'annulation d'un contrat
            var contractVm = {
                IdContract: contract.IdContractOrContractBase,
                NewTargetPrice: contract.NewTargetPrice,
                TargetPriceReached: contract.TargetPriceReached,
                LowerPriceReached: contract.LowerPriceReached,
                IdTypeFixation: contract.IdTypeFixation,
                CoefficientChange: contract.CoefficientChange,
                OfferCurrencyUnit: contract.OfferCurrencyUnit
            };

            if (contract.NewQuantity) {
                contractVm.NewQuantity = Number(contract.NewQuantity.toString().replace(',', '.'));
            }

            if (isCancel) {
                contractVm.NewTargetPrice = null;
            }

            $scope.successMessage = "";
            $scope.loading = true;
            contractsService.UpdateContract(contractVm, function (data, status) {
                if (status !== null) {
                    if (status === 400) {
                        $scope.errorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                        $scope.loading = false;
                    }
                } else {
                    $scope.successMessage = $scope.UpdateSuccessMessage;
                    GetContracts();
                }
            });
        };

        var UpdateContractBase = function (contract, isCancel) {
            // Création de la vm utilisée pour la modification ou l'annulation d'un contrat de base
            var contractBaseVm = {
                IdContractBase: contract.IdContractOrContractBase,
                NewTargetBasePrice: contract.NewTargetPrice,
            };
            if (contract.NewQuantity) {
                contractBaseVm.NewQuantity = Number(contract.NewQuantity.toString().replace(',', '.'));
            }
            if (isCancel) {
                contractBaseVm.NewTargetPrice = null;
            }

            $scope.loading = true;
            contractBaseService.UpdateContractBase(contractBaseVm, function (data, status) {
                if (status !== null) {
                    if (status === 400) {
                        $scope.errorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                        $scope.loading = false;
                    }
                } else {
                    $scope.successMessage = $scope.UpdateSuccessMessage;
                    GetContracts();
                }
            });
        };

        $scope.DuplicateContract = function (idContractCommitment, quantity, targetPrice, idTypeFixation, idFirstComponentContractOrContractBase) {
            $location.path('/user/offers/view/' + enumFactory.TypeOffer.Ferme + '/' + (idContractCommitment ? idContractCommitment : '') + '/' + (quantity ? quantity : '') + '/' + (targetPrice ? targetPrice : '') + '/' + (idTypeFixation ? idTypeFixation : '') + '/' + (idFirstComponentContractOrContractBase ? idFirstComponentContractOrContractBase :''));
        };

        Init();
    }]);
